import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getProps } from '../../bootcamp'

export const getStaticProps = getStaticPropsWrapper(getProps, { campaign: true, path: '/bootcamp' })

export { default } from '../../bootcamp'
